import { render, staticRenderFns } from "./StringAttributeValue.vue?vue&type=template&id=b1a3bfb0"
import script from "./StringAttributeValue.vue?vue&type=script&lang=ts"
export * from "./StringAttributeValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports